import { render, staticRenderFns } from "./ProjectRow.vue?vue&type=template&id=590803f8&scoped=true&"
import script from "./ProjectRow.vue?vue&type=script&lang=ts&"
export * from "./ProjectRow.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectRow.vue?vue&type=style&index=0&id=590803f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590803f8",
  null
  
)

export default component.exports